var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card-actions',{staticClass:"chat-retry"},[(_vm.connecting)?_c('v-progress-linear',{attrs:{"color":"secondary","rounded":"","indeterminate":""}}):_c('v-btn',{attrs:{"color":"secondary darken-2","block":""},on:{"click":function($event){return _vm.$emit('retry')}}},[_vm._v(" "+_vm._s(_vm.$t('chat.retry'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }